import { Directive, inject, input, TemplateRef } from '@angular/core';

import { type DatagridCellContext } from './datagrid-column';

/**
 * Marks an `<ng-template avsCell="columnId" let-row let-index="index">` as the custom cell
 * renderer for that column - projected into `<avs-datagrid>`, resolved by `AvsDatagridComponent`
 * against each `DatagridColumn.id`.
 */
@Directive({
  selector: 'ng-template[avsCell]',
})
export class DatagridCellDirective<TRow = unknown> {
  columnId = input.required<string>({ alias: 'avsCell' });

  templateRef = inject<TemplateRef<DatagridCellContext<TRow>>>(TemplateRef);
}
